import { useId } from 'react';
import styles from './FacebookLogo.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function FacebookLogo({ className }) {
	const classNameArray = className?.split(' ') || [];
  const id = useId();

	return (
		<svg className={cx([...classNameArray])} viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-describedby={`facebook-title-${id}`}>
			<title id={`facebook-title-${id}`}>Facebook</title>
			<path d="M7.5 12.51h2.679l1.071-4.287H7.5V6.081c0-1.104 0-2.143 2.143-2.143h1.607v-3.6C10.9.292 9.582.188 8.189.188c-2.909 0-4.975 1.775-4.975 5.035v3H0v4.286h3.214v9.107H7.5V12.51Z" fill="#202020" />
		</svg>
	);
}
